const steps = [
  {
    step: '01',
    icon: 'ri-search-line',
    title: 'Znajdź produkty',
    desc: 'Przeglądaj kategorie i znajdź interesujące Cię produkty w jednym, uporządkowanym arkuszu. Wszystkie linki i informacje są na wyciągnięcie ręki.',
  },
  {
    step: '02',
    icon: 'ri-file-search-line',
    title: 'Sprawdź informacje',
    desc: 'Analizuj zdjęcia QC, porównuj ceny i czytaj opinie innych użytkowników. Podejmuj świadome decyzje zakupowe.',
  },
  {
    step: '03',
    icon: 'ri-scales-3-line',
    title: 'Porównaj opcje',
    desc: 'Korzystaj z wbudowanych narzędzi porównawczych, aby wybrać najlepszy wariant produktu pod względem ceny i jakości.',
  },
  {
    step: '04',
    icon: 'ri-shopping-bag-3-line',
    title: 'Kupuj bezpiecznie',
    desc: 'Dokonaj zakupu przez Kakobuy z pełną ochroną kupujących i śledź swoje zamówienie aż do dostarczenia pod drzwi.',
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Jak działa Kakobuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            Cztery proste kroki, które zmienią sposób, w jaki robisz zakupy z Chin.
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-1/2 left-[12.5%] right-[12.5%] h-px bg-background-300 -translate-y-1/2"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {steps.map((item, i) => (
              <div
                key={item.step}
                className="relative bg-white rounded-xl p-6 border border-background-200/70 text-center animate-[fadeInUp_0.5s_ease-out]"
                style={{ animationDelay: `${i * 0.15}s` }}
              >
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-accent-500 text-white text-xs font-bold px-3 py-1 rounded-full">
                  {item.step}
                </span>
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 mb-4 mt-2">
                  <i className={`${item.icon} text-xl text-primary-500`}></i>
                </div>
                <h3 className="font-semibold text-sm text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}